<template>
    <img v-if="imgFound" :src="url('/storage/prodotti-gruppi/' + imageElement() + '.jpg')" @error="imgFound = false" @load="imgLoaded"
         alt="product image">
    <img v-else :src="url('/storage/media/articles/placeholder-prodotto.jpg')" @load="imgLoaded" alt="placeholder image">
</template>

<script>

export default {
  props: {
    elm: {type: Object, default: null}
  },

  data: function () {

    return {
      imgFound: true,
      placeholderImages: null,
      loaded: false,
      origFilename: null,
    }

  },

  created: function () {
    //this.getAllImages()
  },

  mounted: function () {

    console.log( this.imageElement() );

  },

  computed: {},

  methods: {
    imgLoaded(){
      this.loaded = true
      this.$emit('imgLoaded', true)
    },
    randomImage: function () {
      return _.sample(this.placeholderImages)

    },
    getAllImages: function () {
      axios({
        method: 'get',
        url: window.location.origin + '/imgProdFileName'
      }).then(res => {

        this.placeholderImages = res.data[0]
      //  console.log(this.placeholderImages);
      }).catch(err => {
        console.log(err.response.data)
      })
    },
    imageElement: function () {

      console.log( this.getValueProp('macrofamily') );

      if( this.getValueProp('macrofamily').toLowerCase() == '4tools' ){

        return this.elm.cod_art;

      } else {

        this.origFilename = [this.getValueProp('macrofamily'),
        this.getValueProp('family').replace('+', 'plus'),
        this.getValueProp('category'),
        this.getValueProp('color'),].join('-').toLowerCase();
          
        return [this.getValueProp('macrofamily'),
          this.getValueProp('family').replace('+', 'plus'),
          this.getValueProp('category'),
          this.getValueProp('color'),].join('-').toLowerCase();

      }


    },

    getValueProp: function (key) {
      return (key in this.elm && this.elm[key] != null) ? this.elm[key].codice : 'null';
    }
  }

}
</script>

<style>

</style>
